<template>
    <div>
         <!-- 保养 -->
      <div v-if="data.type  === 2">
        <info-item label="上次保养里程" :value="data.lastMaintenanceKm"></info-item>
        <info-item label="本次进厂里程" :value="data.incomeKm"></info-item>
        <info-item label="超保里程" :value="data.overMaintenanceKm"></info-item>
        <info-item label="超保费">
          <el-input style="width:80px" v-model="exceedAmount"></el-input> 元
        </info-item>
      </div>
      <!-- 维修 -->
      <div v-if="data.type === 1">
        <info-item label="保险上浮费">
          <el-input style="width:80px" v-model="floatAmount"></el-input> 元
        </info-item>
        <info-item label="车辆折旧费">
          <el-input style="width:80px" v-model="depreciationAmount"></el-input> 元
        </info-item>
      </div>
    </div>
</template>


<script>
import InfoItem from '@/components/infoItem'

export default {
  components: {
    InfoItem,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      exceedAmount: 0,
      floatAmount: 0,
      depreciationAmount: 0,
    }
  },
  watch: {
    exceedAmount(val) {
      this.$emit('priceChange', val, 'exceedAmount')
    },
    floatAmount(val) {
      this.$emit('priceChange', val, 'floatAmount')
    },
    depreciationAmount(val) {
      this.$emit('priceChange', val, 'depreciationAmount')
    },
  },
}
</script>
